import React from 'react'
import GAReportsContainer from '../../modules/GAReports/containers/GAReportsContainer/GAReportsContainer'

const GAReports = () => {
  return (
    <GAReportsContainer />
  )
}

export default GAReports